var __TEMP__ = require('./_apply.js');var apply = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_castPath.js');var castPath = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./last.js');var last = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_parent.js');var parent = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_toKey.js');var toKey = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = castPath(path, object);
  object = parent(object, path);
  var func = object == null ? object : object[toKey(last(path))];
  return func == null ? undefined : apply(func, object, args);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseInvoke;
